/** @format */

import React from 'react';
import FooterNavigation from './navigation';
import Social from '@components/social/social';
import Copyright from './copyright';
import { NavigationProvider } from '@context/navigation-context';
import { StateProvider } from '@context/state-context';
import { TranslationProvider } from '@context/translation-context';

/**
 * Footer.
 */
const Footer = () => {
  /**
   * Render.
   */
  return (
    <NavigationProvider>
      <TranslationProvider>
        <StateProvider>
          <div className="footer-wrapper">
            <div className="footer-container">
              <FooterNavigation type="footer-nav" />
              <div className="social-nav">
                <FooterNavigation type="contact-info-nav" />
                <Social />
              </div>
            </div>
          </div>
          <FooterNavigation type="legal-links" />
          <Copyright />
        </StateProvider>
      </TranslationProvider>
    </NavigationProvider>
  );
};
export default Footer;
